import { Controller } from '@hotwired/stimulus';

/**
 * Simple controller for toggling password visibility
 *
 * Usage:
 * <div data-controller="password-toggle">
 *   <input type="password" data-password-toggle-target="input" />
 *   <button type="button" data-action="click->password-toggle#toggle">
 *     <img data-password-toggle-target="showIcon" src="eye_open.svg" />
 *     <img data-password-toggle-target="hideIcon" src="eye_closed.svg" class="hidden" />
 *   </button>
 * </div>
 */
export default class extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon'];

  toggle() {
    if (!this.hasInputTarget) return;

    const isPassword = this.inputTarget.type === 'password';
    this.inputTarget.type = isPassword ? 'text' : 'password';

    // Toggle icon visibility
    if (this.hasShowIconTarget && this.hasHideIconTarget) {
      this.showIconTarget.classList.toggle('hidden', !isPassword);
      this.hideIconTarget.classList.toggle('hidden', isPassword);
    }

    // Keep focus on input
    this.inputTarget.focus();
  }
}
